/**
 * Telemetry props for the viewport the inspector runs in — captured at
 * activation so we can see the real screen real estate users have (the host
 * page's window in the extension). Pure + window-injected so it's testable and
 * safe in headless/agent contexts (returns {} when there's no window).
 */
export function viewportTelemetryProps(
    win?: { innerWidth?: number; innerHeight?: number; devicePixelRatio?: number } | null,
): Record<string, number> {
    if (!win || typeof win.innerWidth !== "number" || typeof win.innerHeight !== "number") return {};
    const props: Record<string, number> = {
        window_width: Math.round(win.innerWidth),
        window_height: Math.round(win.innerHeight),
    };
    if (typeof win.devicePixelRatio === "number" && win.devicePixelRatio > 0) {
        props.device_pixel_ratio = Math.round(win.devicePixelRatio * 100) / 100;
    }
    return props;
}
